/**
 * The paste / copy toast. A paste can CREATE items and REPLACE existing files (a Replace writes a new
 * version — owner, 2026-10-06), so the toast says both: "Copied 2, replaced 1". Counted with proper
 * plurals ("and 1 other" / "and 2 others") in every locale.
 */
export function pasteToastText(
  t: (key: string, opts?: Record<string, unknown>) => string,
  copiedNames: readonly string[],
  replacedNames: readonly string[],
): string | null {
  const c = copiedNames.length
  const r = replacedNames.length
  if (c === 0 && r === 0) return null
  if (r === 0) {
    return c > 1
      ? t('driveView.toast.copied', { name: copiedNames[0], count: c - 1 })
      : t('driveView.toast.copiedOne', { name: copiedNames[0] })
  }
  if (c === 0) {
    return r > 1
      ? t('driveView.toast.replaced', { name: replacedNames[0], count: r - 1 })
      : t('driveView.toast.replacedOne', { name: replacedNames[0] })
  }
  return t('driveView.toast.pasteSummary', { copied: c, replaced: r })
}
